import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-slate-50 to-[#f8f6ef] text-slate-primary px-5 sm:px-8 lg:px-12 py-16">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h1 className="text-4xl sm:text-5xl font-black text-slate-primary mb-4">
            Terms & Conditions
          </h1>

          <p className="text-slate-500">Effective Date: May 13, 2026</p>
        </div>

        <div className="bg-white/90 backdrop-blur-xl border border-slate-200 rounded-3xl p-6 sm:p-10 space-y-10 shadow-2xl shadow-black/5">
          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              1. Acceptance of Terms
            </h2>

            <p className="text-slate-600 leading-8">
              By accessing or using Just For Points, you agree to comply with and be
              legally bound by these Terms & Conditions. If you do not agree,
              you should not use our platform or services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              2. Informational Purposes Only
            </h2>

            <p className="text-slate-600 leading-8">
              Just For Points provides informational content, reward point
              comparisons, travel insights, and redemption-related tools. We do
              not provide financial, investment, legal, or tax advice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              3. No Guarantee of Accuracy
            </h2>

            <p className="text-slate-600 leading-8">
              Reward values, airline availability, transfer ratios, travel
              pricing, and promotional offers may change at any time. We do not
              guarantee the accuracy, completeness, or reliability of
              information displayed.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              4. Third-Party Providers
            </h2>

            <p className="text-slate-600 leading-8">
              Airlines, banks, hotel programs, and travel providers referenced
              on our platform are independent third parties. Their trademarks,
              logos, and services remain the property of their respective
              owners.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              5. User Conduct
            </h2>

            <ul className="list-disc pl-6 text-slate-600 leading-8 space-y-2">
              <li>Do not misuse or interfere with the platform</li>
              <li>Do not attempt unauthorized access</li>
              <li>Do not use automated scraping tools without permission</li>
              <li>Do not engage in fraudulent or illegal activities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              6. Intellectual Property
            </h2>

            <p className="text-slate-600 leading-8">
              All website content, branding, software, design, graphics, and
              platform features are owned by Just For Points unless otherwise stated
              and are protected by intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              7. Disclaimer of Warranties
            </h2>

            <p className="text-slate-600 leading-8">
              The platform is provided on an “as is” and “as available” basis
              without warranties of any kind, express or implied.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              8. Limitation of Liability
            </h2>

            <p className="text-slate-600 leading-8">
              Just For Points shall not be liable for indirect, incidental,
              consequential, or special damages arising from your use of the
              platform, including reward losses, booking issues, pricing errors,
              or travel disruptions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              9. Termination
            </h2>

            <p className="text-slate-600 leading-8">
              We reserve the right to suspend or terminate access to users who
              violate these Terms & Conditions or misuse the platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              10. Governing Law
            </h2>

            <p className="text-slate-600 leading-8">
              These Terms & Conditions shall be governed by and interpreted
              under the laws of the United States and applicable state laws,
              without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              11. Changes to Terms
            </h2>

            <p className="text-slate-600 leading-8">
              We may update these Terms & Conditions periodically. Continued use
              of the platform after updates constitutes acceptance of the
              revised terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-primary mb-4">
              12. Contact Information
            </h2>

            <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5">
              <p className="text-voyage-cyan font-semibold">
                jfpcustomersupport@gmail.com
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
